export default __webpack_public_path__ + "static/media/navBannerImg1.33e22ff1.png";